export default {
  categories: [
    {
      image: 'https://m.media-amazon.com/images/I/41DH6EElmEL._SL500_.jpg',
      displayName: 'Friggitrici ad aria',
      slug: 'friggitrici-ad-aria',
    },
    {
      image: 'https://m.media-amazon.com/images/I/41RY7dYPwCL._SL500_.jpg',
      displayName: 'Telefoni samsung',
      slug: 'telefoni-samsung',
    },
    {
      image: 'https://m.media-amazon.com/images/I/41MUFHbESaL._SL500_.jpg',
      displayName: 'Smartphone',
      slug: 'smartphone',
    },
    {
      image: 'https://m.media-amazon.com/images/I/51LnXxJRq2L._SL500_.jpg',
      displayName: 'Smartwatch',
      slug: 'smartwatch',
    },
    {
      image: 'https://m.media-amazon.com/images/I/21yFM6Ie9OL._SL500_.jpg',
      displayName: 'Deumidificatore',
      slug: 'deumidificatore',
    },
  ],
  popularCategories: ({device = 'desktop'}: {device: 'desktop' | 'mobile'}) => [
    {
      image: `https://dt47coepsakuj.cloudfront.net/images/${device}/categories-vacuums-floor-care.png`,

      title: 'Vacuums & Floor Care',
      categories: [
        {title: 'Robotic Vacuums', href: '/robotic-vacuums'},
        {title: 'Upright Vacuums', href: '/upright-vacuums'},
        {title: 'Steam Mops', href: '/vacuum-mops'},
        {title: 'Handheld Vacuums', href: '/handheld-vacuums'},
      ],
    },
    {
      image: `https://dt47coepsakuj.cloudfront.net/images/${device}/categories-computers-accessories.png`,

      title: 'Computers & Accessories',
      categories: [
        {title: 'Laptops', href: '/laptops'},
        {title: 'Gaming Laptops', href: '/gaming-laptops'},
        {title: 'Cable Modem', href: '/cable-modem'},
        {title: 'Dell Laptops', href: '/dell-laptops'},
      ],
    },
    {
      image: `https://dt47coepsakuj.cloudfront.net/images/${device}/categories-outdoor-recreation.png`,
      title: 'Outdoor Recreation',
      categories: [
        {title: 'Inflatable Paddle Boards', href: '/inflatable-paddle-boards'},
        {title: 'Instant Tents', href: '/instant-tents'},
        {title: 'Beach Chairs', href: '/beach-chairs'},
        {title: 'Cooler Like Yeti', href: '/cooler-like-yeti'},
      ],
    },
    {
      image: `https://dt47coepsakuj.cloudfront.net/images/${device}/categrories-television-video.png`,
      title: 'Television & Video',
      categories: [
        {title: 'Roku Devices', href: '/roku-devices'},
        {title: '55 inch TVs', href: '/55-inch-tvs'},
        {title: '43 inch TVs', href: '/43-inch-tvs'},
        {title: '32 inch Smart TVs', href: '/32-inch-smart-tvs'},
      ],
    },
  ],
}
